export const environment = {
  production: false,
  //API: "http://localhost:3000",
  API_KEY: '4d8c221e33msh9ecd9d0797606b2p140be0jsn8ef45e027606',
  GATEWAY_URL: 'https://api-auth.imlchile.cl',
  BACKEND_URL: 'https://api-rrhh.imlchile.cl',
  API: "https://api-rrhh.imlchile.cl"
  // API: "http://apps.grupofirma.cl:4040"
};
